import { RESET_STATE } from 'store/global/actions';

import { PREVIEW_ACTION_TYPE } from '../actions';
import { EMPTY_MARGIN_PREVIEW } from '../marginCenter.constants';

const initialState = { data: EMPTY_MARGIN_PREVIEW, isLoading: false, hasError: false };

const previewReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case PREVIEW_ACTION_TYPE.SET_PREVIEW_LOADING:
      return { ...state, isLoading: payload, hasError: payload ? false : state.hasError };

    case PREVIEW_ACTION_TYPE.SET_PREVIEW_ERROR:
      return { ...state, isLoading: false, hasError: true };

    case PREVIEW_ACTION_TYPE.GET_MARGIN_PREVIEW:
      return { data: payload ?? EMPTY_MARGIN_PREVIEW, isLoading: false, hasError: false };

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default previewReducer;
